import { render, staticRenderFns } from "./FooterSponsors.vue?vue&type=template&id=daba8088&scoped=true"
import script from "./FooterSponsors.vue?vue&type=script&lang=js"
export * from "./FooterSponsors.vue?vue&type=script&lang=js"
import style0 from "./FooterSponsors.vue?vue&type=style&index=0&id=daba8088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daba8088",
  null
  
)

export default component.exports